import React from "react";
import Svg from "react-svg-inline";

const Icon = ({ name, className, height, width }) =>
  <Svg
    svg={require(`!raw-loader!../icons/${name}.svg`)}
    className={className}
    height={`${height}px`}
    width={`${width}px`}
  />;

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon.js